import React, { Component } from "react";

import { MnemoLoading, SuccessNotification } from "components/misc";
import { Container, Row, Col } from "design-react-kit";
import { MTextArea } from "components/forms";
import { networkErrorHelper, utilsService } from "libs";

export class MakeSeedTrainingRiconoscimentoAttendance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedFile: null, // Stato per il file selezionato
      preparedRows: [],
    };
  }
  
    // Funzione per inviare il file all'API
    uploadFile = async () => {
      const { selectedFile } = this.state;
  
      if (!selectedFile) return;
  
      this.setState({ loading: true });
  
      const formData = new FormData();
      formData.append("file", selectedFile);
  
      utilsService
        .uploadTrainingRiconoscimentoAttendance(formData)
        .then(({ data }) => {

          SuccessNotification.render(
            "Importazione andata a buon fine.",
            "Comunicazione"
          );
  
          this.setState({
            loading: false,
            selectedFile: null,
            preparedRows: data.payload.preparedRows || [],
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            selectedFile: null,
          });
  
          networkErrorHelper.notify(error);
          console.log(error);
        });
    };

  //--- ---

  render() {
    const { loading, selectedFile } = this.state;

    return (
      <>
        {loading && <MnemoLoading></MnemoLoading>}

        <Container>
          <Row>
            <Col md={12} className="mt-3">
              <h3 className="mb-2">
                Importazione Riconoscimento Tirocinio:
              </h3>

              <div className="m-0">
                <div className="uploadForm">
                  {/* Input file nascosto */}
                  <input
                    className="uploadFormFile"
                    type="file"
                    accept=".csv, .xls, .xlsx"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      this.setState({ selectedFile: file });
                    }}
                    style={{ display: "none" }}
                    ref={(input) => (this.fileInput = input)}
                  />

                  {/* Bottone per selezionare il file */}
                  <div className="wrapperUploadBtn">
                    <button
                      className="btn btn-primary bg-dark"
                      onClick={() => this.fileInput.click()}
                    >
                      Seleziona un file da importare
                    </button>

                    {selectedFile && (
                      <p className="uploadFileName">{selectedFile.name}</p>
                    )}
                  </div>

                  {/* Bottone per caricare il file */}
                  <button
                    className="btn btn-primary bg-dark"
                    onClick={this.uploadFile}
                    disabled={!selectedFile}
                  >
                    IMPORTA FILE E GENERA SEED
                  </button>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col md={12} className="mt-3">
              <div>Elementi: {this.state.preparedRows.length}</div>
              <MTextArea value={JSON.stringify(this.state.preparedRows, null, 2)} rows={12} />
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
